<template>
  <div class="question-wrapper-drivepoint-small">
    <div class="portlet light" style="overflow: hidden">
      <div class="portlet-title">
        <div class="caption">
          <span class="caption-subject bold uppercase">
            <i
              v-show="question.playing"
              style="font-size: 1.2em"
              class="fa fa-volume-up"
              aria-hidden="true"
            ></i>
            <i class="fa fa-book" aria-hidden="true"></i>
            <a
              :href="question.url"
              target="_blank"
            >{{ question.bookReference }} {{ showID ? `(ID: ${question.id})` : '' }}</a>
          </span>
        </div>
      </div>
      <div class="portlet-body">
        <!-- text -->
        <div class="outside-text-wrapper">
          <div class="text-wrapper" @click="$emit('playSound', question.sound, question.id)">
            <div class="text">{{ question.text }}</div>
          </div>
        </div>

        <!-- image -->
        <div class="image">
          <img
            :src="question.image"
            alt
            v-if="question.image"
            @click="isZoomed=!isZoomed"
            @mouseover="isZoomed=!isZoomed"
            @mouseleave="isZoomed = false"
            :class="{zoomed: isZoomed}"
          >
        </div>

        <!-- options -->
        <div class="options-wrapper">
          <transition-group name="options" tag="div" appear>
            <div
              class="option"
              v-for="option in question.options"
              :key="option.id"
              @click="clickOption(option, question)"
              :class="{
                             wrong: ((!showCorrect && question.tempSelectedOption === option) || question.selectedOption === option) && !option.is_correct,
                             correct: option.is_correct && ( question.selectedOption === option || showCorrect || question.tempSelectedOption === option || (question.tempSelectedOption && !question.tempSelectedOption.is_correct))
                             }"
            >{{ option.text }}</div>
          </transition-group>
        </div>

        <hr style="margin: 10px">
        <!-- toolbar -->
        <div class="q-toolbar-small clearfix" style="margin-bottom: 0px">
          <!-- label and section-->
          <div class="labels">
            <question-label :question="question"></question-label>
            <category-label :question="question"></category-label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionLabel from "../QuestionLabel.vue";
import CategoryLabel from "../CategoryLabel.vue";
import ExplanationModal from "../driving-test-components/ExplanationModal.vue";

export default {
  data() {
    return {
      isZoomed: false,
      showModal: false
    };
  },
  props: ["question", "userSignedIn", "showID", "showCorrect"],
  components: { QuestionLabel, CategoryLabel, ExplanationModal },
  methods: {
    clickOption(option, question) {
      this.$emit("playSound", option.sound, question.id);
      question.tempSelectedOption = option;
    },
    openModal() {
      this.showModal = true;
      this.$nextTick(function() {
        $("#" + this.question.explanationId).modal();
      });
    },
    changeLanguage(lang) {
      this.question.changeLang(lang);
    }
  }
};
</script>